import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_projects/projects/$projectId/stats/')({
  loader: () => {
    return {
      crumb: 'Stats',
    };
  },
});
